



















import { defineComponent } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "MoreMenuMoney",
  components: { BaseSpinner, BaseIconButton, FormatMoney },
  props: {
    balance: { type: Number, required: true },
    showPayoutRequestButton: { type: Boolean, required: true },
  },
  setup(_, { root }) {
    const handleRefillBalanceClick = () => {
      emitter.emit(EVENTS.BALANCE_REFILL_SHOW, true);
    };

    const handlePayoutClick = () => {
      root.$router.push({ name: "payoutRequests" });
    };

    return { handleRefillBalanceClick, handlePayoutClick };
  },
});
